import { Heading } from '@chakra-ui/react'
import { TextProps } from './utils'

const Title = ({ children, ...textProps }: TextProps) => (
  <Heading as="h1" fontSize="4xl" fontWeight={600} {...textProps}>
    {children}
  </Heading>
)

export { Title }
